import { mailListItemAnimationStore } from 'owa-mail-list-item-animation-store';

export function invokeAnimationCallbacks() {
    mailListItemAnimationStore.animationCallbacks?.forEach(callback => callback?.());
}
